import { render, staticRenderFns } from "./CertificateCheckZbperson.vue?vue&type=template&id=b1b40e36&scoped=true&"
import script from "./CertificateCheckZbperson.vue?vue&type=script&lang=js&"
export * from "./CertificateCheckZbperson.vue?vue&type=script&lang=js&"
import style0 from "./CertificateCheckZbperson.vue?vue&type=style&index=0&id=b1b40e36&scoped=true&lang=css&"
import style1 from "./CertificateCheckZbperson.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b40e36",
  null
  
)

export default component.exports